var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleX(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12348",
    "data-name": "Group 12348",
    transform: "translate(-4774 10713)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_397",
    "data-name": "Ellipse 397",
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    transform: "translate(4774 -10713)",
    fill: "#f7f8f9"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2176",
    "data-name": "Line 2176",
    x2: 5,
    y2: 5,
    transform: "translate(4781 -10706)",
    fill: "none",
    stroke: "#383c3a",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2177",
    "data-name": "Line 2177",
    x1: 5,
    y2: 5,
    transform: "translate(4781 -10706)",
    fill: "none",
    stroke: "#383c3a",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleX);
export default __webpack_public_path__ + "static/media/circle-x.91b91a194bc9fbeeee89e5d062120cab.svg";
export { ForwardRef as ReactComponent };